import { useState, useEffect } from 'react';
import { toHttps } from '@/utils/miscUtils';

const usePagination = (initialItems, initialNextPage, fetchPage) => {
  const [items, setItems] = useState(initialItems);
  const [nextPage, setNextPage] = useState(toHttps(initialNextPage));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setItems(initialItems);
    setNextPage(toHttps(initialNextPage));
  }, [initialItems, initialNextPage]);

  const loadMore = async () => {
    if (!nextPage || loading) return;

    setLoading(true);
    try {
      const { data } = await fetchPage(nextPage);
      setItems(prev => [...prev, ...(data.results ?? [])]);
      setNextPage(toHttps(data.next));
    } catch (err) {
      console.error('Failed to load more items:', err);
    } finally {
      setLoading(false);
    }
  };

  return {
    items,
    loading,
    hasMore: !!nextPage,
    loadMore,
  };
};

export default usePagination;
